import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { animated, useSpring } from '@react-spring/web';
import { interpolate as d3interpolate } from 'd3';

import { Comp } from '@redsift/design-system';

import { LineProps } from './types';
import { StyledLine } from './styles';
import { monochrome } from '../../scheme';
import { config } from '../../config';

const COMPONENT_NAME = 'Line';
const CLASSNAME = 'redsift-line';

export const Line: Comp<LineProps, SVGGElement> = forwardRef((props, ref) => {
  const { color = monochrome, data, isSelected: propsIsSelected, role } = props;

  const { className, createLine, disableAnimations, previousData = [], ...forwardedProps } = props;

  const interpolator = d3interpolate(previousData, data);

  const isSelectable = role === 'option';
  const isDeselected = isSelectable && propsIsSelected === false;

  const animatedProps = useSpring({
    ...config,
    to: async (next: (props?: object) => Promise<void>) => {
      await next({ t: 1 });
    },
    from: { t: 0 },
  });

  return (
    <StyledLine {...forwardedProps} ref={ref} className={classNames(Line.className, className)}>
      <animated.path
        d={
          config.immediate || disableAnimations
            ? (createLine(data) as unknown as string)
            : (animatedProps.t.to((t) => createLine(interpolator(t))) as unknown as string)
        }
        fill="none"
        stroke={isDeselected ? 'var(--redsift-color-neutral-light-grey)' : color}
        strokeWidth={2}
      />
    </StyledLine>
  );
});
Line.className = CLASSNAME;
Line.displayName = COMPONENT_NAME;
